import "./userTicketBox.css";
import React, { useEffect, useState } from "react";
import { withNamespaces } from "react-i18next";


import ErrorComponent from "../../ErrorComponent/ErrorComponent";
import Loading from "../../Loading/Loading";
import { Button } from "antd";
import useFetch from "../../../hooks/UseFetch";
import { AuthContextValue } from "../../../context/AuthContext";
import { GetContextValue } from "../../../context/GetContext";

function UserTicketBox({ t,supportNumber }) {
  const { token } = AuthContextValue();
  const { notificationRender } = GetContextValue();

  const [ticket, setTicket] = useState({});
  const [ticketStatus, setTicketStatus] = useState(1);
  const [ticketColor, setTicketColor] = useState("#fff1b8");

  const [photo, setPhoto] = useState(null);
  const [photoModalOpen, setPhotoModalOpen] = useState(false);

  const handleOpenPhotoModal = (photo) => {
    setPhoto(photo);
    setPhotoModalOpen(true);
  };
  const handleClosePhotoModal = () => {
    setPhotoModalOpen(false);
  };

  const {
    setUseFetchRender: setTicketUseFetchRender,
    useFetchRender: ticketUseFetchRender,
    error: ticketError,
    loading: ticketLoading,
    data: ticketData,
  } = useFetch(
    `${
      process.env.REACT_APP_GET_SUPPORT_LIST_URL
    }?SupportNumber=${supportNumber}&Page=${1}&PageSize=${1}`,
    token
  );

  
  useEffect(() => {
    if (ticketData && ticketData[0]) {
      setTicket(ticketData[0]);
      setTicketStatus(
        ticket.status === 1
          ? t("select_options_wait")
          : ticket.status === 2
          ? t("select_options_under_review")
          : ticket.status === 3
          ? t("select_options_solved")
          : ticket.status === 4
          ? t("select_options_not_resolve")
          : ticket.status === 5
          ? t("select_options_concluded")
          : t("select_options_wait")
      );
      setTicketColor(
        ticketData[0].status === 1
          ? "#fff1b8"
          : ticketData[0].status === 2
          ? "#ffd8bf"
          : ticketData[0].status === 3
          ? "#d9f7be"
          : ticketData[0].status === 4
          ? "#ffccc7"
          : ticketData[0].status === 5
          ? "#b5f5ec"
          : "#fff1b8"
      );
    }
  }, [ticketData]);

  useEffect(() => {
    setTicketUseFetchRender(!ticketUseFetchRender);
  }, [notificationRender, supportNumber]);

  return (
    <>
      {ticketError ? (
        <ErrorComponent error={ticketError} />
      ) : ticketLoading ? (
        <Loading />
      ) : ticket && ticket.supportNumber ? (
        <div
          className="user-ticket-box"
          style={{ backgroundColor: ticketColor }}
        >
          <h3>
            {" "}
            <strong>{t("support_request_ticket_title")} :</strong> {ticket.title}
            <span className="date">{ticket.createdDate}</span>
          </h3>

          <hr />

          <p>
            {" "}
            <strong>{t("support_request_number")} :</strong> {ticket.supportNumber}
          </p>
          <p>
            {" "}
            <strong>{t("support_request_description")} :</strong> {ticket.body}
          </p>

          <p>
            <strong>{t("support_request_photo")} :</strong>{" "}
            <Button onClick={() => handleOpenPhotoModal(ticket.images[0])}>
            {t("support_request_photo_button")}
            </Button>
          </p>

          <p>
            <strong>{t("support_request_status")} : </strong> {ticketStatus}
          </p>

          {ticket.description && (
            <div className="admin-reply">
              <span className="date">{ticket.approvedDate}</span>
              <h4>{t("support_request_admin_answer")} :</h4>
              <p>{ticket.description}</p>
            </div>
          )}
        </div>
      ) : (
        <p className="table-null-text">{t("message_no_support_request")}</p>
      )}
      {photoModalOpen && (
        <div className="photo-modal-container" onClick={handleClosePhotoModal}>
          <div className="photo-box">
            <button className="close-button" onClick={handleClosePhotoModal}>
              x
            </button>
            <img className="ticket-image" src={photo} alt="Ticket" />
          </div>
        </div>
      )}
    </>
  );
}

export default withNamespaces()(UserTicketBox);
